// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__rja5R","logoContainer":"footer_logoContainer__mdVXn","copyright":"footer_copyright__6MgL3"};